import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo-small.png";

const Footer = () => {
  const navigate = useNavigate();
  const configData = useSelector((state) => state.config.data);
 const { t } = useTranslation();

  return (
    <>
      <footer class="footer">
        <div class="footer-top">
          <div class="footer-section logo-text">
            <img
              src={configData?.website_logo ? configData?.website_logo : Logo}
              alt=""
              className="cursor-pointer footer-logo"
              onClick={() => {
                navigate("/");
              }}
              style={{ maxHeight: "50px", width: "auto" }}
            />
            <p>
            {t("footer.playFavoriteGames")}
              <br />
              {t("footer.singlePlatform")}
            </p>
           
          </div>
          <div class="footer-links-section">
            <div class="footer-sub-section">
              <h4> {t("footer.pages")}</h4>
              <ul>
                <li>{t("footer.responsibleGaming")}</li>
                <li>{t("footer.selfExclusion")}</li>
                <li>{t("footer.payout")}</li>
                <li>{t("footer.disputeResolution")}</li>
                <li>{t("footer.registration")}</li>
              </ul>
            </div>

            <div class="footer-sub-section">
              <h4>{t("footer.contactUs")}</h4>
              <a href="mailto:support@zillibetsworld.com">
                support@zillibetsworld.com
              </a>
              <div class="social-icons">
                <i class="fa-brands fa-instagram"></i>
                <i class="fa-brands fa-facebook"></i>
                <i class="fa-brands fa-telegram"></i>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div class="footer-bottom">
          <p>© copyright 2024 by ZilliBets | All rights reserved.</p>
          <div class="footer-links">
            <a href="#">Privacy Policy</a> |<a href="#">Terms & Conditions</a> |
            <a href="/contact-us">Contact Us</a>
          </div>
        </div>

        <div class="footer-disclaimer">
          <strong>{t("footer.disclaimer")}:</strong>{t("footer.registerNote")}
         
          <a href="#"> {t("footer.generalTerms")}</a>
          {t("footer.updateNote")} 
        </div>
      </footer>
    </>
  );
};

export default Footer;
